import {
  getAll,
  read,
  unread,
  readAll,
} from '@/services/notifications-service';

const actions = {
  loadNotifications({ commit, state }, agentId) {
    getAll(agentId).then((notifications) => {
      notifications.forEach((notification) => {
        notification.agent_notify_read_display = notification.agent_notify_read;
      });
      commit('SET_MISC_NOTIFICATIONS', notifications);
      commit('REFRESH_PAUSE_NOTIFICATIONS');
    });
  },
  appendPauseNotification({ commit }, notification) {
    commit('APPEND_PAUSE_NOTIFICATION', notification);
  },
  async readNotification({ commit }, agentNotifyId) {
    await read(agentNotifyId);
  },
  async unreadNotification({ commit }, agentNotifyId) {
    await unread(agentNotifyId);
  },
  async readAll({ commit, state }, agentId) {
    commit('READ_ALL');
    await readAll(agentId);
  },
  toggleRead({ commit, state }, agentNotifyId) {
    commit('TOGGLE_READ', agentNotifyId);
  },
};

export default actions;
